import { useEffect } from 'react';

const ScheduleDemo = () => {
  useEffect(() => {
    if (window.oaiq) {
      window.oaiq("measure", "registration_completed", {
        type: "customer_action",
        amount: 0,
        currency: "USD"
      });
    }
  }, []);

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
      <p>Schedule a Demo</p>
    </div>
  );
};

export default ScheduleDemo;
